export const ownedUserIds = (profile) => {
  const ids = new Set();
  const add = (value) => {
    if (value === null || value === undefined || value === "") return;
    ids.add(String(value));
  };

  add(profile?.userId);
  add(profile?.user_Id);
  add(profile?.id);
  add(profile?.userID);
  (profile?.roles || []).forEach((role) => {
    add(role?.userId);
    add(role?.user_Id);
  });
  Object.keys(profile?.profilesByUserId || {}).forEach(add);

  return ids;
};

export const belongsToSomeoneElse = (ownedIds, candidateUserId) =>
  ownedIds.size > 0 &&
  candidateUserId !== null &&
  candidateUserId !== undefined &&
  candidateUserId !== "" &&
  !ownedIds.has(String(candidateUserId));

const STAFF_ROLES = new Set([0, 1, 2]);

export const isStaffProfile = (profile) =>
  Boolean(profile?.isSuperAdmin) ||
  (profile?.roles || []).some((role) => STAFF_ROLES.has(role?.role ?? role?.roleId));
